const STORAGE_KEY = 'enchliving:ready-to-ship-only';
const BODY_CLASS = 'enchliving-ready-to-ship-only';
const TOGGLE_SELECTOR = '[data-enchliving-ready-to-ship-toggle]';

function getStoredState() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}

function persistState(active) {
  try {
    localStorage.setItem(STORAGE_KEY, active ? '1' : '0');
  } catch (e) {
  }
}

function applyState(active) {
  document.body.classList.toggle(BODY_CLASS, active);

  document.querySelectorAll(TOGGLE_SELECTOR).forEach((input) => {
    if (input.checked !== active) {
      input.checked = active;
    }
  });
}

function handleChange(event) {
  const target = event.target;
  if (!target || !target.matches(TOGGLE_SELECTOR)) return;

  const form = target.closest('form');
  const active = !!target.checked;

  if (form && form.hasAttribute('update-on-change')) {
    persistState(active);
    applyState(active);
  } else {
    if (form) {
      form.dataset.enchReadyToShipPending = active ? '1' : '0';
    } else {
      persistState(active);
      applyState(active);
    }
  }
}

function handleApplyButtonClick(event) {
  const btn = event.target.closest('button[is="facet-apply-button"]');
  if (!btn) return;

  const form = btn.form || btn.closest('form') || document.querySelector('form#facet-form');
  if (!form) return;

  if (typeof form.dataset.enchReadyToShipPending !== 'undefined') {
    const pending = form.dataset.enchReadyToShipPending === '1';
    persistState(pending);
    applyState(pending);
    delete form.dataset.enchReadyToShipPending;
  }
}

function applyUrlOverride() {
  try {
    const params = new URLSearchParams(window.location.search);
    const forced = params.get('ench_ready_to_ship');
    if (forced !== 'on' && forced !== 'off') return null;
    const forcedActive = forced === 'on';
    persistState(forcedActive);
    try {
      params.delete('ench_ready_to_ship');
      const qs = params.toString();
      const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    } catch (e) {
    }
    return forcedActive;
  } catch (e) {
    return null;
  }
}

function init() {
  if (window.__enchlivingReadyToShipSwitchInit) return;
  window.__enchlivingReadyToShipSwitchInit = true;

  const override = applyUrlOverride();
  applyState(override !== null ? override : getStoredState());

  document.addEventListener('change', handleChange);

  document.addEventListener('click', handleApplyButtonClick);

  document.addEventListener('facet:updated', () => {
    const stored = getStoredState();
    applyState(stored);
    setTimeout(function () {
      const retry = getStoredState();
      applyState(retry);
    }, 200);
  });

  document.addEventListener('dialog:after-show', () => {
    const state = getStoredState();
    applyState(state);
    setTimeout(function () {
      const retry = getStoredState();
      applyState(retry);
    }, 200);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

export {};
